/**
 * OpenAPI client uses RxJS `ajax`; non-2xx responses throw the Ajax response object (`status`, `response`, …).
 * See `@exagens/behavioral-insight-console-client` `runtime.js` `request()` throwing `res` when status ∉ [200,300).
 */
export const isSparxBlueprintNotFoundError = (error: unknown): boolean => {
  if (error == null || typeof error !== "object") {
    return false;
  }
  const { status } = error as { status?: unknown };
  return status === 404;
};
